// src-mlr/components/cta/cta.component.js
import { CtaController } from '@common/components/cta/cta.component';
import template from '@common/components/cta/cta.tpl.html';

class MlrCtaController extends CtaController {
  static $inject = CtaController.$inject.concat(["userService"]);

  constructor(...args) {
    super(...args.slice(0, CtaController.$inject.length));
    this.$userService = args[CtaController.$inject.length];

    this.user = {};
    this.error = false;

  }

  async $onInit() {
    await super.$onInit();
    // Otherwise, it will be undefined from the base, and this default will apply.
    this.btnclass = this.btnclass || 'btn btn-primary btn-lg';
    this.btnarrow = this.btnarrow !== undefined ? this.btnarrow : 'mlr-icon mlr-arrow-right-long'

    // This runs after all data has been set in both controllers.
    if (!this.$scope.$$phase) {
      this.$scope.$apply();
    }

  }

  async optin($e) {
    let modalBasePath = `${this.AppService.config.pubPath}/modals/`;

    const specialModalPages = [];

    if (this.page && specialModalPages.indexOf(this.page.id) > -1) {
      this.modalinc = this.$sce.trustAsResourceUrl(`./${modalBasePath}modal.${this.page.id}.html`);
    }

    await super.optin($e);
  }

  async onClick() {
    super.onClick();
  }

  async submitMlrSpecificForm(formData) {
    console.log("MlrCtaController: Submitting MLR-specific form:", formData);
  }
}

class MirCtaComponent {
  bindings = {
    btntext: '@?',
    action: '@?',
    target: '@?',
    btnclass: '@?',
    btnarrow: '@?',
    btnalign: '@?'
  };
  template = template;
  controller = MlrCtaController;
}

export default angular
  .module('mlrcta.component', [])
  .component('mlrcta', new MirCtaComponent())
  .name;